import React, { useState } from "react";
import css from "./Contact.module.css";
import { useFormik } from "formik";
import axios from "axios";
import { config } from "./Config";
import emailpic from "../assets/email.png";
import { FaGithubSquare } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Slide, Zoom, Flip, Bounce } from "react-toastify";
import { Link } from "react-router-dom";

import { motion } from "framer-motion";
import {
  draw,
  fadeIn,
  slideIn,
  staggerChildren,
  textVariant2,
  zoomIn,
} from "..//utils/motion";

const Contact = () => {
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      message: "",
    },
    validate: (values) => {
      let error = {};
      if (values.name === "") {
        error.name = "please enter Name";
      }
      if (values.email === "") {
        error.email = "please enter Email";
      }
      if (
        values.email &&
        !/^[A-Z0-9._%+-]+@[A-Z0-9._]+\.[A-z]{2,4}$/i.test(values.email)
      ) {
        error.email = " please enter a valid Email";
      }
      if (values.message === "") {
        error.message = "please enter Message";
      }

      return error;
    },
    onSubmit: async (values) => {
      try {
        setButtonLoading(true);

        const server = await axios.post(`${config.api}/send/mail`, values);
        if (server.data.message === "Mail sended successfully") {
          toast.success(server.data.message, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setTimeout(() => formik.resetForm(), 3000);
          setButtonLoading(false);

          // setTimeout(() => navigate("/home"), 5000);

          // formik.resetForm();
        } else if (server.data.message === "something went wrong") {
          toast.error("Something went worng, try later", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setButtonLoading(false);
        }
      } catch (error) {}
    },
  });
  const [messageDispaly, setmessageDisplay] = useState("Show");

  const [messageType, setmessageType] = useState("message");
  const changeType = () => {
    if (messageType === "message") {
      setmessageDisplay("Hide");
      setmessageType("text");
    } else {
      setmessageType("message");
      setmessageDisplay("Show");
    }
  };

  const [buttonLoading, setButtonLoading] = useState(false);

  return (
    <>
      {/* <div className={css.contactbg} id='contact'> */}
      <a className="position_atag" id="contact"></a>

      <div
        //  id='contact'

        className={css.contactbg}
      >
        {/* <div className={css.firstcontainer}>
            <img src={emailpic}/>
        </div> */}
        {/* <div className={css.absone}>
        </div>
        <div className={css.abstwo}>
        </div> */}
        {/* <form className={css.secondcontainer}> */}
        <motion.form
          variants={staggerChildren}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.25 }}
          className={css.secondcontainer}
        >
          <motion.div variants={textVariant2}>
            <h6>GET IN TOUCH</h6>
            <h3>Contact.</h3>
          </motion.div>

          <motion.div variants={textVariant2} className={css.inputpair}>
            <label>Your Name</label>
            <input
              className={css.input}
              type="text"
              placeholder="What's your good name?"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              id={`
                          ${
                            formik.touched.name && formik.errors.name
                              ? `${css.errorbox}`
                              : ""
                          }
                          ${
                            formik.touched.name && !formik.errors.name
                              ? `${css.successbox}`
                              : ""
                          }
 
                          `}
            />
            <div>
              {" "}
              {formik.touched.name && formik.errors.name ? (
                <span className={css.err}>{formik.errors.name} </span>
              ) : null}
            </div>
          </motion.div>
          <motion.div variants={textVariant2} className={css.inputpair}>
            <label>Your Email</label>

            <input
              className={css.input}
              type="email"
              placeholder="What's your email address?"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              id={`
                          ${
                            formik.touched.email && formik.errors.email
                              ? "error-box"
                              : ""
                          }
                          ${
                            formik.touched.email && !formik.errors.email
                              ? "success-box"
                              : ""
                          }
 
                          `}
            />
            <div>
              {formik.touched.email && formik.errors.email ? (
                <span className={css.err}>{formik.errors.email} </span>
              ) : null}
            </div>
          </motion.div>

          <motion.div variants={textVariant2} className={css.inputpair}>
            <label>Your Message</label>

            <textarea
              className={`${css.input} ${css.inputtextarea}`}
              type="text"
              placeholder="What you want to say?"
              name="message"
              value={formik.values.message}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              id={`
                          ${
                            formik.touched.message && formik.errors.message
                              ? "error-box"
                              : ""
                          }
                          ${
                            formik.touched.message && !formik.errors.message
                              ? "success-box"
                              : ""
                          }
 
                          `}
            ></textarea>
            <div>
              {formik.touched.message && formik.errors.message ? (
                <span className={css.err}>{formik.errors.message} </span>
              ) : null}
            </div>
          </motion.div>

          <motion.button
            variants={textVariant2}
            onClick={formik.handleSubmit}
            type="submit"
            className={
              buttonLoading ? `${css.inputButtonactive}` : `${css.inputButton}`
            }
          >
            {buttonLoading ? (
              <>
                <div class="spinner-box">
                  <div class="pulse-container">
                    <div class="pulse-bubble pulse-bubble-1"></div>
                    <div class="pulse-bubble pulse-bubble-2"></div>
                    <div class="pulse-bubble pulse-bubble-3"></div>
                  </div>
                </div>
              </>
            ) : (
              "Send"
            )}
          </motion.button>

          {/* <div></div> */}
          {/* </form>
           */}
        </motion.form>

        {/* <div className={css.firstcontainer}> */}
        <motion.div
          variants={staggerChildren}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.25 }}
          className={css.firstcontainer}
        >
          <motion.div variants={textVariant2}>
            <h2>Email</h2>
            <a href="mailto:vinothvishnu12@gmail.com">
              vinothvishnu12@gmail.com
            </a>
          </motion.div>
          <motion.div variants={textVariant2}>
            <h2>Address</h2>
            <p>Kundrathur, Chennai-69</p>
            <p>Tamil Nadu</p>
            <p>India</p>
          </motion.div>
          <motion.div variants={textVariant2}>
            {/* <h2>Social platform</h2> */}
            <a
              className={css.atag}
              href="https://github.com/vno-thvishnu"
              target="_blank"
            >
              <FaGithubSquare />
            </a>
            <a
              className={css.atag}
              href="https://www.linkedin.com/in/vno-th-vishnu-569b40270/"
              target="_blank"
            >
              <FaLinkedin />
            </a>
          </motion.div>
        </motion.div>
        {/* </div> */}
      </div>
      {/* </div> */}

      <ToastContainer
        transition={Flip}
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </>
  );
};

export default Contact;
